import type { LandingConfig, ServiceFit } from "./server/landingTypes";

export const BOOK_CALL_URL = "https://cal.com/zohaib-a";

export const defaultLandingConfig: LandingConfig = {
  heroKicker: "AI-era Product Engineering",
  heroHeadline: "Your AI build, through to production.",
  heroLead:
    "Lovable and Replit get you 80% there, fast. We'll take it the rest of the way - hardened for real users and scale.",
  skills: ["TypeScript", "React", "Next.js", "Node", "Lovable", "Replit"],
  beforeAfter: [
    {
      key: "payments",
      label: "Payments",
      before: "Charges confirmed in the browser, webhooks ignored",
      after: "Server-side charges, webhook-verified, idempotent",
    },
    {
      key: "subscriptions",
      label: "Subscriptions",
      before: "Cancel never revokes access, no renewal handling",
      after: "Stripe lifecycle synced - upgrades, cancels, dunning",
    },
    {
      key: "auth",
      label: "Auth & access",
      before: "RLS off - any user can read every row",
      after: "Row-level security, roles enforced server-side",
    },
    {
      key: "data",
      label: "Data integrity",
      before: "No validation, no migrations, trusts the client",
      after: "Validated, migrated, backed up, no orphan rows",
    },
    {
      key: "security",
      label: "Secrets & security",
      before: "API keys shipped in the frontend bundle",
      after: "Keys server-only, rotated, rate-limited",
    },
  ],
  caseStudyOrder: ["FairyHomes", "OneMind", "Peaque"],
  serviceFit: "Takeover",
  ctaLabel: "Book a Call",
  profileNote: "ThroughPilot landing page",
};

export type Service = {
  id: ServiceFit;
  tag: string;
  title: string;
  subtitle: string;
  bullets: Array<string>;
  when: {
    prefix: string;
    emphasis: string;
  };
};

export const services: Array<Service> = [
  {
    id: "Launchpad",
    tag: "01 - Launchpad",
    title: "MVP → Production",
    subtitle: "You have an idea",
    bullets: [
      "Product & UX design from scratch",
      "Full-stack build on a production-grade stack",
      "Auth, payments and data done right the first time",
      "Shipped, deployed and handed over",
    ],
    when: { prefix: "ships in", emphasis: "weeks" },
  },
  {
    id: "Takeover",
    tag: "02 - Takeover",
    title: "Lovable / Replit rescue",
    subtitle: "Your AI build stalled as it grew",
    bullets: [
      "Audit of payments, subscriptions, auth & data",
      "Re-architect the backend for real users",
      "Close the security & integrity gaps",
      "Take it the rest of the way to production",
    ],
    when: { prefix: "live in", emphasis: "days" },
  },
  {
    id: "Embed",
    tag: "03 - Embed",
    title: "Staff augmentation",
    subtitle: "You need senior hands",
    bullets: [
      "Senior Product Engineering on your team",
      "Ship features alongside your devs",
      "Code review & architecture guidance",
      "Flexible, by the month",
    ],
    when: { prefix: "", emphasis: "monthly" },
  },
];
